import React, { useEffect, useState } from "react";
import "./App.css";
import "./pages/Home/Home.css";
import Home from "./pages/Home/Home";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import LoginPage from "./pages/login/LoginPage";
import { Cookies } from "react-cookie";
import { getAlert } from "./api/admins";
import ViewSeparatePage from "./pages/Separates/ViewSeparate";
import UpdateSeparatePage from "./pages/Separates/UpdateSeparate";
import ViewPrimaryPage from "./pages/PrimaryProjects/ViewPrimary";
import UpdatePrimaryPage from "./pages/PrimaryProjects/UpdatePrimary";
import ViewPropertiesPage from "./pages/PrimaryProjects/ViewProperties";
import ViewPropertyPage from "./pages/PrimaryProjects/ViewProperty";
import AddPropertyPage from "./pages/PrimaryProjects/AddProperty";
import ViewResaleComponent from "./pages/Resale/ViewResale";
import ViewDeal from "./pages/Deals/viewDeal";
import ViewCil from "./pages/Cils/viewCil";
import ViewForm from "./pages/Forms/viewForm";
import AssignPage from "./pages/Admins/assign";
import TeamPage from "./pages/Admins/team";

function App() {
  return (
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  );
}

function AppWrapper() {
  const [existList, setExistList] = useState(null);
  const navigate = useNavigate();
  const cookie = new Cookies();

  const [isLogin, setIsLogin] = useState(cookie.get("token"));

  useEffect(() => {
    if (!isLogin && window.location.pathname.split("/")[1] !== "guest") {
      navigate("/login");
    }
  }, [isLogin]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage setIsLogin={setIsLogin} />} />
      <Route path="/" element={<Home />} />
      <Route path="/separate/:id" element={<ViewSeparatePage />} />
      <Route path="/update_separate/:id" element={<UpdateSeparatePage />} />
      <Route path="/primary/:id" element={<ViewPrimaryPage />} />
      <Route path="/update_primary/:id" element={<UpdatePrimaryPage />} />
      <Route path="/properties/:id/:fromId" element={<ViewPropertiesPage />} />
      <Route path="/update_properties/:id" element={<ViewPropertyPage />} />
      <Route path="/add_property/:id" element={<AddPropertyPage />} />
      <Route path="/resale/:id" element={<ViewResaleComponent />} />
      <Route path="/cil/:cilType/:id" element={<ViewCil />} />
      <Route path="/form/:formType/:id" element={<ViewForm />} />
      <Route path="/deals/id/:id" element={<ViewDeal />} />
      <Route path="/assign/:id" element={<AssignPage />} />
      <Route path="/team/:id" element={<TeamPage />} />{" "}
    </Routes>
  );
}

export default App;
